var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuHambClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/MenuHamb_close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/MenuHamb_close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8588848,3.31268812 C18.5282371,2.64333579 19.7030445,2.73248175 20.4852814,3.51471863 C21.2675183,4.2969555 21.3566642,5.47176291 20.6873119,6.14111524 L20.6873119,6.14111524 L14.8284258,11.9998899 L20.6873119,17.8588848 C21.3578006,18.5293735 21.2675183,19.7030445 20.4852814,20.4852814 C19.7030445,21.2675183 18.5293735,21.3578006 17.8588848,20.6873119 L11.9994258,14.8278899 L6.14111524,20.6873119 C5.50787587,21.3205513 4.42581036,21.2752016 3.64856243,20.6092354 L3.51471863,20.4852814 C2.73248175,19.7030445 2.64219937,18.5293735 3.31268812,17.8588848 L3.31268812,17.8588848 L9.17142578,11.9998899 L3.31268812,6.14111524 C2.64333579,5.47176291 2.73248175,4.2969555 3.51471863,3.51471863 C4.2969555,2.73248175 5.47176291,2.64333579 6.14111524,3.31268812 L11.9994258,9.17088993 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHambClose);
export default __webpack_public_path__ + "static/media/MenuHamb_close.8f643e7e493df5205412f9e47c9a123c.svg";
export { ForwardRef as ReactComponent };